import { getApiBaseUrl } from '../config/apiBase';

async function parseJson(response, endpointName) {
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload || payload.success !== true) {
    throw new Error(payload?.error || `[${endpointName}] Request failed`);
  }
  return payload;
}

export async function fetchCollarSchema() {
  const response = await fetch(`${getApiBaseUrl()}/drilling_database/get_dh_coll_schema.php`, {
    credentials: 'include',
  });
  return parseJson(response, 'get_dh_coll_schema.php');
}

export async function fetchCollarValues({ column, dataset, q, limit = 80 } = {}) {
  const response = await fetch(`${getApiBaseUrl()}/drilling_database/get_dh_coll_values.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      column,
      DataSet: dataset || undefined,
      q: q || undefined,
      limit,
    }),
  });
  return parseJson(response, 'get_dh_coll_values.php');
}

export async function queryDatabaseHoles({
  dataset,
  filters,
  intervalMode = 'assay',
  isplan = false,
  maxRows = 20000,
  countOnly = false,
  desurvey = false,
  surveysOnly = false,
  stage,
  keys,
  offset,
  pageSize,
} = {}) {
  const response = await fetch(`${getApiBaseUrl()}/drilling_database/query_dh_holes.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      DataSet: dataset || undefined,
      filters,
      interval_mode: intervalMode,
      IsPlan: isplan ? 1 : 0,
      max_rows: maxRows,
      count_only: countOnly ? 1 : 0,
      desurvey: desurvey ? 1 : 0,
      surveys_only: surveysOnly ? 1 : 0,
      stage: stage || undefined,
      keys: Array.isArray(keys) && keys.length ? keys : undefined,
      offset: offset != null ? offset : undefined,
      page_size: pageSize || undefined,
    }),
  });
  return parseJson(response, 'query_dh_holes.php');
}
